import "../styles/whatsapp.scss";
import { logos,items } from "../services/data.ts";

export const Whatsapp =() =>{
    const size  =70
    return(
        <a href={items.whatsapp} id="whatsapp-ref">
            <img src={logos.whatsapp} height={size} width={size}  id="whatsapp-button"/>
        </a>
    )
}

export const WhatsappBurger =() =>{
    const size  =70
    return(
        <a href={items.whatsapp} id="whatsapp-ref">
            <img src={logos.whatsapp} height={size} width={size}  id="whatsapp-burger"/>
        </a>
    )
}